import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/SideMenu.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
